import { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setSelectedCabins } from '../../actions/checkout-la-actions'
import get from 'lodash/get'
import RoomPopup from '../popups/RoomPopup'
import CabinItem from './CabinItem'
import useGuestSplitting from './hooks/useGuestSplitting'
import useCurrentShop from './hooks/useCurrentShop'

export default function Cabins({ cabins, selectedTrip, areaFormat }) {
  const dispatch = useDispatch()
  const { shopInfo } = useCurrentShop()
  const { splitGuestsToCabins, selectGuestPopup } = useGuestSplitting()
  const [roomInfo, setRoomInfo] = useState(false)
  const closeRoomPopup = () => setRoomInfo(false)

  const onCabinQtyChange = (selectedItem) => {
    const cabinsList = [...cabins]
      .map((cabin) => {
        if(cabin.roomCategory.id === selectedItem.roomCategory.id) {
          selectedItem.pricesToShow.forEach((item) => {
            if(item.isDiver) {
              cabin.diversToGo = item.qty || 0
            } else {
              cabin.nonDiversToGo = item.qty || 0
            }
          })

          cabin.totalGuests = cabin.diversToGo + cabin.nonDiversToGo
        }
        return cabin
      })
      .filter((item) => item.totalGuests)
    dispatch(setSelectedCabins(cabinsList))
  }

  const goToStep3 = () => {
    splitGuestsToCabins()
  }

  return (
    <Fragment>
      {cabins.map((cabin, index) => {
        return (
          <CabinItem
            goToStep3={goToStep3}
            callback={get(
              selectGuestPopup,
              `[${cabin?.roomCategory.id}].callback`,
              false
            )}
            selectedTrip={selectedTrip}
            openRoomPopup={setRoomInfo}
            currency={shopInfo.currency}
            onSelectCallback={onCabinQtyChange}
            cabin={cabin}
            key={index}
            isLastItem={index + 1 === cabins.length}
          />
        )
      })}

      {roomInfo && (
        <RoomPopup
          isOpen
          roomInfo={roomInfo}
          closeModal={closeRoomPopup}
          areaFormat={areaFormat}
        />
      )}
    </Fragment>
  )
}
